import { FC, useContext, useState, useMemo, useCallback } from "react";
import styles from "./styles.module.scss";
import axios from "axios";
import { Notification, Popover } from '@douyinfe/semi-ui';
import { useRouter } from "next/router";
// import MyModal from "../modal";
import { IndexContext } from "@/stores";


export interface IFooterProps {

}

export const Footer: FC<IFooterProps> = ({

}) => {
  const [visible, setVisible] = useState(false)
  const router = useRouter()
  const { time } = useContext(IndexContext);
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  })

  const onChage = useCallback((e: any, type: 'name' | 'email') => {
    const data = { ...formData }
    data[type] = e.target.value
    setFormData(data)
  }, [formData])

  const btnClick = useCallback(async () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.name && !formData.email) {
      Notification.open({
        content: '请填写完整信息',
        duration: 3,
      })
      return
    }
    if (!regex.test(formData.email)) {
      Notification.open({
        content: '请填写正确邮箱',
        duration: 3,
      })
      return
    }
    const { data } = await axios.post('/api/subscribe', {
      truename: formData.name,
      email: formData.email
    })
    Notification.open({
      content: data?.msg,
      duration: 3,
    })
    if (data?.code) {
      setFormData({
        name: '',
        email: ''
      })
      window.scrollTo(0, 0)
    }

  }, [formData])

  return (
    <div className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.left}>
          <img src="/image/footer-logo.png?v=20250422" alt="" />
          <p>CBCE亚洲国际精酿啤酒会议暨展览会</p>
          <p style={{ fontSize: '14px' }} className={styles.info}>
            <span className={styles.time}>{time.start_time}-{time.end_time}</span>
            <span className={styles.site}>{time.address}</span>
          </p>
        </div>
        <div className={styles.middle}>
          <h3>快速连接</h3>
          <ul>
            <li><a href="/about/survey">关于CBCE</a></li>
            <li><a href="https://cbce2025.gration.cn/?exhibitor/login/=" target="_blank">展商中心</a></li>
            <li><a href="https://cbce2025.gration.cn/?member/register&code=sites" target="_blank">观众中心</a></li>
            <li><a href="/summit/2025">CBCE技术峰会</a></li>
            <li><a href="/schedule">同期活动</a></li>
            <li><a href="/media/news">媒体中心</a></li>
            <li><a href="/contacts">联系我们</a></li>
          </ul>
        </div>
        <div className={styles.right}>
          <h3>关注我们</h3>
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/craft-beer-china-88915036a?fromQR=1" target="_blank" >
                <img src="http://img.cbcechina.com/2025-08-05/30d51834d3fa948a276eb64403b2b0d2.png" alt="" />
              </a>
            </li>
            <li>
              <a href="https://v.douyin.com/NFXodmxAHkc/ 9@0.com" target="_blank" >
                <img src="http://img.cbcechina.com/2025-08-05/876af54adcaf9e4470e33e511482fbff.png" alt="" />
              </a>
            </li>
            <li>
              <a href="https://www.xiaohongshu.com/user/profile/5f5cccbb000000000101d16c?xsec_token=YB_XNj9ey4eGBDnITikPc6BsIHvf8GG6Cd67CqbHFTkQQ=&xsec_source=app_share&xhsshare=CopyLink&appuid=5f5cccbb000000000101d16c&apptime=1754291150&share_id=a16d9bc498994075864959d8d8250075" target="_blank" >
                <img src="http://img.cbcechina.com/2025-08-05/36d6f4803f7a41136b4c1ef614fe6cee.png" alt="" />
              </a>
            </li>
            <li>
              <Popover
                position="top"
                content={
                  <img style={{ width: '150px' }} src="/image/wx-account-qr.png" alt="" />
                }
              >
                <img src="http://img.cbcechina.com/2025-08-05/9b174d252a963effeb1cac53618e9477.png" alt="" />
              </Popover>
            </li>
            <li>
              <Popover
                position="top"
                content={
                  <img style={{ width: '150px' }} src="/image/wxqr.jpg?v=2025" alt="" />
                }
              >
                <img src="http://img.cbcechina.com/2025-08-05/82a875113392d4226000bb0e957c1d28.png" alt="" />
              </Popover>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.copyright}>
        <div>
          <div>
            <a style={{ color: '#fff' }} target="_blank" href="https://www.nm-china.com.cn/"><p>纽伦堡会展(上海)有限公司 版权所有 © 2022</p></a>
            <a style={{ color: '#fff' }} target="_blank" href="http://beian.miit.gov.cn/"><p>沪ICP备09011147号-7</p></a>
          </div>
          <div>
            <div>
              <span>主办单位：</span>
              <img src="/image/messe-logo.png?v=20250422" alt="" />
              <img src="/image/beer.png" alt="" />
            </div>
            <div>
              <span>技术提供：</span>
              <a style={{ color: '#fff' }} target="_blank" href="https://www.smartinfo.cn/"><span>SMART-INFO</span></a>
            </div>
          </div>
        </div>

      </div>

      {/* <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal> */}
    </div>
  );
};
